import { useScrollReveal } from "@/hooks/useScrollReveal";

export default function Reveal({
  children,
  className = "",
  as: Component = "div",
  y = 40,
  x = 0,
  scale = 1,
  opacity = 0,
  duration = 0.9,
  ease = "power3.out",
  start = "top 85%",
  stagger,
  childrenSelector,
  delay = 0,
  rotateX = 0,
  rotateY = 0,
}) {
  const ref = useScrollReveal({
    y,
    x,
    scale,
    opacity,
    duration,
    ease,
    start,
    stagger,
    children: childrenSelector,
    delay,
    rotateX,
    rotateY,
  });

  return (
    <Component ref={ref} className={className}>
      {children}
    </Component>
  );
}
